export default {
  'memberPoint.title': 'メンバーポイント',
  'memberPoint.loyalty.title': 'キャンペーンポイント',
  'memberPoint.loyalty.name': 'キャンペーン名',
  'memberPoint.detail': '詳細',
  'memberPoint.store': '店舗',
  'memberPoint.point': 'ポイント',
  'memberPoint.source': '出所',
  'memberPoint.update_time': 'ポイント獲得時刻',
  'memberPoint.deduct_time': 'ポイント利用時刻',
  'memberPoint.expired_at': '有効期限',
  'memberPoint.note': '備考',
  'memberPoint.details': '説明',
  'memberPoint.current_point': '現在の累計ポイント',
  'memberPoint.issue_date': 'ポイント付与日',
  'memberPoint.date': '期間',
  'memberPoint.expired': '期限間近',
  'memberPoint.case': 'イベント',
  'memberPoint.receiver': '受取人',
  'memberPoint.transfer': '贈与者',
  'memberPoint.record': 'ポイント履歴',
  'memberPoint.benefit': 'ポイント特典',
} as Record<string, string>;
